export default __webpack_public_path__ + "static/media/online-facilitation.0e6c74c6.svg";